/*
 * @Descripttion: 内嵌iframe框架的展示弹窗
 * @Author: 曹博
 * @Date: 2023-12-07 11:03:22
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-07 13:27:20
 */
import { Button, Modal, ModalProps } from 'antd'

interface Props extends ModalProps {
  srcUrl: string // 内嵌iframe所需路径
  closeModal?: () => void
}

const IframeModal = (props: Props) => {
  const { srcUrl, closeModal, ...restProps } = props
  return (
    <Modal
      {...restProps}
      style={{ top: '16%' }}
      closable={false}
      width={'60%'} // 宽度
      bodyStyle={{ padding: 0, height: '60vh' }}
      footer={[
        <Button type="primary" onClick={() => closeModal?.()} key="confirmBtn">
          确认
        </Button>,
      ]}
    >
      <iframe src={srcUrl} width="100%" height="100%" />
    </Modal>
  )
}
export default IframeModal
/*
 * @Descripttion: 内嵌iframe框架的展示弹窗
 * @Author: 曹博
 * @Date: 2023-12-07 11:03:22
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-07 13:27:20
 */
import { Button, Modal, ModalProps } from 'antd'

interface Props extends ModalProps {
  srcUrl: string // 内嵌iframe所需路径
  closeModal?: () => void
}

const IframeModal = (props: Props) => {
  const { srcUrl, closeModal, ...restProps } = props
  return (
    <Modal
      {...restProps}
      style={{ top: '16%' }}
      closable={false}
      width={'60%'} // 宽度
      bodyStyle={{ padding: 0, height: '60vh' }}
      footer={[
        <Button type="primary" onClick={() => closeModal?.()} key="confirmBtn">
          确认
        </Button>,
      ]}
    >
      <iframe src={srcUrl} width="100%" height="100%" />
    </Modal>
  )
}
export default IframeModal
